'use client';
import { createContext } from 'react';
export const initStat = {
    isInitializing: true
};
export const FlagshipContext = createContext({
    state: { ...initStat }
});
